export default __webpack_public_path__ + "static/media/绅士漫画.ce7313c8.png";